/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unsafe-optional-chaining */
import Button from "@mui/material/Button";
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { FacebookIcon, FacebookShareButton, TwitterIcon, TwitterShareButton } from "react-share";
import { useDispatch, useSelector } from "react-redux";
import { Box, Divider, useMediaQuery } from "@mui/material";
import { useRouter } from "next/router";
import moment from "moment";
import IconContinue from "../../../../../public/assets/icons/IconContinue";
import IconRedo from "../../../../../public/assets/icons/IconRedo";
import IconShare from "../../../../../public/assets/icons/IconShare";
import PlusCircle from "../../../../../public/assets/icons/PlusCircle";
import { formatTime, genSignature, getNonce, isEmpty } from "../../../../utils/helpers/helpers";
import CongratulationAlertDialog from "../../dialog/CongratulationAlertDialog";
import AlertDialog from "../../dialog/AlertDialog";
import { commonActions } from "../../redux/actions";
import AnalysisGeneral from "./AnalysisGeneral";
import { eventTracking } from "../../../../firebase/firebaseConfig";
import { IQuizState } from "../../../topics/utils/type";
import { TCommonState } from "../../utils/type";
import { clientKeyAdsInHouse, secretKeyAdsInHouse, uidAdsInHouse } from "../../../../utils/constants/env";
import {
  ADS_PAGE_POSITION_QUIZ,
  BREAK_SCORE_TO_GET_SUBJECT_PARAM,
  POSITION_ADS_IN_HOUSE,
  removeNullAttributeFromObject,
  stringToSlug
} from "../../utils/constant";
import AdsInHouseBlock from "../AdsInHouseBlock";
import { accountActions } from "../../../account/redux/actions";
import { TAccountState } from "../../../account/utils/types";
import { TArenaState } from "../../../arena/utils/types";

const MAX_ITEM_VIEW_ADS_IN_HOUSE = 3;

export default function ResultQuizDetail({
  progress,
  subjectName,
  quizInfoSubmit,
  redoFunc,
  isShowContinueButton,
  continueFunction,
  openAlertDialogTimeOut,
  setOpenGgAd,
  numOfPractice,
  isArena,
  dataAnalysis,
  isDialog = false
}) {
  const [isShare, setIsShare] = useState<any>();
  const [openAlertDialog, setOpenAlertDialog] = useState(false);
  const dispatch = useDispatch();
  const router = useRouter();
  const { congratulation, userInfos, adsInHouses, grade } = useSelector(
    (state: { commonNew: TCommonState }) => state.commonNew
  );
  const { goals } = useSelector((state: { account: TAccountState }) => state.account);
  const notify = useSelector((state: { commonNew: { notify: any } }) => state.commonNew.notify);
  const { practice } = useSelector((state: { quizCore: IQuizState }) => state.quizCore);
  const { latestData } = useSelector((state: { arenaRoom: TArenaState }) => state.arenaRoom);
  const matches768 = useMediaQuery("(min-width:768px)");
  const scoreQuiz = progress.finished_quiz && Number((progress.correct_quiz / numOfPractice) * 10)?.toFixed(2);
  const adsInHousesQuiz = adsInHouses?.filter((ads) => ads.position === POSITION_ADS_IN_HOUSE.quiz);

  const handleGetAdsInHouseQuizPage = () => {
    const params: any = {
      timestamp: moment().unix(),
      nonce: getNonce(),
      grade: router?.query?.grade,
      uid: uidAdsInHouse,
      position: ADS_PAGE_POSITION_QUIZ,
      // school: userInfos?.member?.school,
      province: userInfos?.member?.city,
      platform: "web",
      device_cd: userInfos?.device?.device_cd,
      is_impression: 1,
      accurate: 1
    };
    const subject = goals?.subject_types?.find(
      (e) => e.slug === stringToSlug(isArena ? latestData?.subject?.title : practice?.subject?.title)
    );
    const pointTarget = goals?.goal_subjects?.find((e) => e.subject_type_id === subject?.id)?.point_target;
    if (pointTarget && scoreQuiz < pointTarget) {
      params.subject_types = [subject?.slug];
    } else if (!pointTarget && scoreQuiz < BREAK_SCORE_TO_GET_SUBJECT_PARAM) {
      params.subject_types = [subject?.slug];
    }
    if (params?.subject_types) {
      const finalParams = removeNullAttributeFromObject(params);
      const dataGetListAds = {
        ...finalParams,
        signature: genSignature(finalParams, clientKeyAdsInHouse, secretKeyAdsInHouse)
      };
      dispatch(commonActions?.handleGetAdsInHouse(dataGetListAds));
    }
  };
  const handleGetGoals = () => {
    dispatch(accountActions.handleGetGoals({ grade_slug: grade }));
  };

  React.useEffect(() => {
    if (isArena) {
      eventTracking("view_are_exam_result");
    }
  }, [isArena]);
  React.useEffect(() => {
    if (goals?.correct_quiz_rate === 0) {
      // get goals để lấy thông tin get list ads
      handleGetGoals();
    }
  }, []);
  React.useEffect(() => {
    if (goals?.correct_quiz_rate > 0) {
      handleGetAdsInHouseQuizPage();
    }
  }, [goals]);

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "0px 12px"
      }}
      className="w-full"
    >
      <span className="text-[18px] font-semibold">
        <FormattedMessage id="topicAnalysis.result.title" />
      </span>
      <Box display="flex" flexDirection="column" mt={2}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          className={`${isDialog ? "px-4" : "lg:px-4"} pb-2`}
        >
          <Box className="bigDot border-greenQuiz text-greenQuiz">
            <Box className="center-col">
              <span className="text-[23px]">{progress?.correct_quiz}</span>
              <span className="text-[10px]">
                <FormattedMessage id="topicAnalysis.correct.title" />
              </span>
            </Box>
          </Box>
          <Box className="bigDot border-red text-red">
            <Box className="center-col">
              <span className="text-[23px]">
                {progress?.finished_quiz - progress?.correct_quiz - progress?.skipped_quiz}
              </span>
              <span className="text-[10px]">
                <FormattedMessage id="topicAnalysis.wrong.title" />
              </span>
            </Box>
          </Box>
          <Box className="bigDot border-orangeQuiz text-orangeQuiz">
            <Box className="center-col">
              <span className="text-[23px]">{progress?.skipped_quiz}</span>
              <span className="text-[10px]">
                <FormattedMessage id="IDS_Ignore" />
              </span>
            </Box>
          </Box>
        </Box>
        <Box className="flex flex-col gap-y-4 text-[15px] text-blackQuiz">
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <span>
              <FormattedMessage id="CreateRoom.subjectField" />
            </span>
            <Box
              className="web-kit-hidden-1"
              style={{
                textAlign: "center"
              }}
            >
              {subjectName}
            </Box>
          </Box>
          <Divider />
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <span>
              <FormattedMessage id="ResultQuizzes.correctRatio" />
            </span>
            <Box className="center-row">
              {progress ? Math.round((progress.correct_quiz / progress.finished_quiz) * 100) : 0}%
            </Box>
          </Box>
          <Divider />
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <span>
              <FormattedMessage id="ResultQuizzes.totalQuizz" />
            </span>
            <Box className="center-row">{numOfPractice}</Box>
          </Box>
          <Divider />
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <span>
              <FormattedMessage id="ResultQuizzes.exp_point" />
            </span>
            <Box className="center-row">{(quizInfoSubmit?.exp_point || progress?.correct_quiz) as number}</Box>
          </Box>
          <Divider />
          {(quizInfoSubmit?.progress?.spent_time || progress?.spent_time) && (
            <div>
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <span>
                  <FormattedMessage id="ResultQuizzes.timeQuizz" />
                </span>
                <Box className="center-row">
                  {formatTime(openAlertDialogTimeOut || quizInfoSubmit?.progress?.spent_time || progress?.spent_time)}
                </Box>
              </Box>
              <Divider />
            </div>
          )}
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <span>
              <FormattedMessage id="ResultQuizzes.averagePerQuestion" />
            </span>
            <Box className="center-row">
              {progress?.spent_time ? (progress.spent_time / progress.finished_quiz)?.toFixed(1) : 0}s
            </Box>
          </Box>
          <Divider />
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <span>
              <FormattedMessage id="ResultQuizzes.scoreQuiz" />
            </span>
            <Box className="center-row">
              {progress.finished_quiz && Number((progress.correct_quiz / numOfPractice) * 10)?.toFixed(2)}
            </Box>
          </Box>
          <Divider />
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Box display="flex">
              <span>
                <FormattedMessage id="ResultQuizzes.reward_diamond" />
              </span>
              &nbsp;
              <button
                type="button"
                onClick={() => {
                  eventTracking("select_result_add_dia", {}, () => setOpenAlertDialog(true));
                }}
                className="text-[10px] font-[400] text-yellow-gradient flex items-center"
              >
                <PlusCircle />
                <FormattedMessage id="ResultQuizzes.reward_diamond.more" />
              </button>
            </Box>
            <Box className="center-row">{quizInfoSubmit?.diamonds || 0}</Box>
          </Box>
          <Divider sx={{ borderBottomWidth: 3 }} />
        </Box>
      </Box>
      {!isEmpty(dataAnalysis?.score_range) && (
        <div>
          <AnalysisGeneral scoreRange={dataAnalysis?.score_range} isIpad={false} />
          {!isDialog && <Divider sx={{ borderBottomWidth: 3 }} />}
        </div>
      )}
      {!isDialog && (
        <Box display="flex" mt={2} className="gap-[10px]">
          {!isArena && (
            <Button
              className="button-result-quiz lg:px-4 lg:w-[143px]"
              size="medium"
              variant="outlined"
              startIcon={<IconRedo />}
              onClick={() => {
                eventTracking(
                  "select_redo",
                  {
                    id: practice?.id,
                    title: practice?.title,
                    type: router?.pathname?.includes("de-thi") ? "exam" : "practice"
                  },
                  () => redoFunc()
                );
              }}
            >
              <span className="text-[14px] normal-case font-[400] text-blackQuiz">
                <FormattedMessage id="QuestionResult.redo" />
              </span>
            </Button>
          )}

          {isShowContinueButton && (
            <Button
              className="button-result-quiz lg:px-4 lg:w-[143px]"
              size="medium"
              variant="outlined"
              startIcon={<IconContinue />}
              onClick={() =>
                eventTracking(
                  "select_continue",
                  {
                    id: practice?.id,
                    title: practice?.title,
                    type: router?.pathname?.includes("de-thi") ? "exam" : "practice"
                  },
                  () => continueFunction()
                )
              }
            >
              <span className="text-[14px] normal-case font-[400] text-blackQuiz">
                <FormattedMessage id="common.continue" />
              </span>
            </Button>
          )}
          {!isShowContinueButton && (
            <Box>
              <Button
                className="button-result-quiz lg:px-4 lg:w-[143px]"
                size="medium"
                variant="outlined"
                onClick={() => setIsShare(!isShare)}
                startIcon={<IconShare />}
              >
                <span className="text-[14px] normal-case font-[400] text-blackQuiz">
                  <FormattedMessage id="QuestionResult.share" />
                </span>
              </Button>
              {isShare && (
                <Box display="flex" mt={1}>
                  <FacebookShareButton url={window.location.href}>
                    <FacebookIcon size={32} round />
                  </FacebookShareButton>
                  &nbsp; &nbsp;
                  <TwitterShareButton url={window.location.href}>
                    <TwitterIcon size={32} round />
                  </TwitterShareButton>
                </Box>
              )}
            </Box>
          )}
        </Box>
      )}
      {matches768 && (
        <>
          <Divider sx={{ borderBottomWidth: 3, padding: "10px 0" }} />
          <Box className="mt-2">
            {adsInHousesQuiz?.slice(0, MAX_ITEM_VIEW_ADS_IN_HOUSE)?.map((ads) => (
              <Box key={ads.activity_uid} className="py-3">
                <AdsInHouseBlock adsInHouse={ads} />
              </Box>
            ))}
          </Box>
        </>
      )}
      {congratulation?.isOpenCongratulation && (
        <CongratulationAlertDialog
          openDialog={congratulation?.isOpenCongratulation}
          data={congratulation?.congratulation}
          handleCloseDialog={() => dispatch(commonActions.deleteCongratulation())}
          triggerFunc={() => dispatch(commonActions.handleGetUserInfo())}
        />
      )}
      {notify?.isOpenDialog && (
        <AlertDialog
          open={notify?.isOpenDialog}
          title="Thông báo"
          setOpen={() => {}}
          content={`${notify?.message}(${notify?.errorCode})`}
          triggerFunc={() => {
            dispatch(commonActions.deleteNotify());
          }}
          contentKey="common.note"
          styleContent={{ textAlign: "center", width: "100%" }}
          buttonOkKey="common.ok"
          isHideCancel
          notifyError
        />
      )}
      {openAlertDialog && (
        <AlertDialog
          open={openAlertDialog}
          setOpen={setOpenAlertDialog}
          title="Thông báo"
          content={<FormattedMessage id="common.viewsAds" />}
          triggerFunc={() => {
            setOpenGgAd(true);
          }}
          contentKey="common.note"
          styleContent={{ textAlign: "center", width: "100%" }}
          buttonOkKey="IDS_View_Ads"
        />
      )}
    </Box>
  );
}
